
export const setPosts = (state, posts) => {
    state.posts = posts
    state.loading = false
}

export const setCurrentPost = (state, post) => {
    state.currentPost = post
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
